export default [
  {
    title: '2024 대한민국 녹색건축 대전<br />산업통상자원부 장관상 수상',
    date: '2024. 09',
    desc: '데이터 센터 각 세종은 지속가능성을 고려한 설계와 친환경 설비 구축 등 탄소감축에 기여한 점을 높게 평가 받아  산업통상자원부 장관상 수상자로 선정되었습니다.'
  },
  {
    title: 'ISO 14001 환경경영시스템<br />인증 취득',
    date: '2021. 07',
    desc: 'ISO 14001 인증을 통해 환경경영시스템을 구축하고 온실가스, 에너지, 물, 폐기물 등 환경영향을 절감할 수 있는 운영 정책을 적극적으로 개발하고 시행합니다.'
  },
  {
    title: '2018 한국에너지공단<br />대한민국 에너지 챔피언 선정',
    date: '2018. 11',
    desc: '에너지 절감과 온실가스 배출 감소, 물 재활용 등 지속적인 친환경 노력을 통해 2017년에 이어 2018년에도 에너지 챔피언에 선정되었습니다.'
  },
  {
    title: '2018 기후변화센터 <br />제8회 기후변화 <br />그랜드 리더스 어워드 수상',
    date: '2018. 11',
    desc: '데이터센터 각 건물 내 LED 조명과 태양광 설치로 전기 에너지 절감과 온실가스 배출이 감소 되었으며, 데이터센터 부지에 옥상 녹화와 에코 매트를 통한 녹지 회복 부분에서 가점을 받았습니다.'
  },
  {
    title: '2017 한국에너지공단 <br />대한민국 에너지 챔피언 선정',
    date: '2017. 11',
    desc: '스노우 멜팅, 태양광 및 태양열 발전, 외부 공기를 통한 자연 냉각 시스템 활용 등 효율적인 데이터센터 운영을 인정받아 에너지 챔피언에 선정되었습니다.'
  },
  {
    title: '세계 10대 아름다운 <br />데이터센터 선정',
    date: '2017. 06',
    desc: "팔만대장경을 보관한 '장경각' 정신의 계승과 친환경 설계 기술이 돋보인다는 평가 아래 영국 IT 전문지 '데이터센터다이내믹스'에서 선정한 세계 10대 아름다운 데이터센터로 선정되었습니다."
  },
  {
    title: '2016 기후 위크 <br />기후 변화 대응 및 <br />온실가스 감축 유공자 포상',
    date: '2016. 11',
    desc: '산업통상자원부가 주최하는 ‘기후 위크 2016’ 행사에서 고효율 친환경 데이터센터를 구축하고, 친환경 가치 확산에 일조함과 동시에 관련 R&D 투자 확대 공로를 인정받아 유공자 포상을 받았습니다.'
  },
  {
    title: '2015 제7회 <br />인공지반녹화대상 대상 수상',
    date: '2015. 10',
    desc: '전체 옥상 녹화 면적이 1만 ㎡에 이르며, 옥상 녹화 및 비탈 녹화를 실시하고 춘천 지역 자생종을 사전 재배 후 시공하는 방법을 사용한 것에 가점을 받아 대상을 수상했습니다. (커넥트윈과 공동 수상)'
  },
  {
    title: '2014 한국건축문화대상 <br />우수상',
    date: '2014. 11',
    desc:
      '환경과 조화를 이루고, 한국 건축의 정통성과 현대성이 구현된 건축물을 찾는 한국건축문화대상에서 우수상을 수상했습니다. 계단식 논 형태의 건물, 자연색을 닮은 루버, 서버관 옥상 위 생태로 등에서 가점을 받았습니다.'
  }
];
